import { LockOpenOutlined, WarningRounded } from "@material-ui/icons";
import { Modal as BSModal } from "react-bootstrap";
import { confirmable } from "react-confirm";
import styled from "styled-components";
import Button from "../Button";
import { SubHeader } from "../Header";

const Modal = styled(BSModal)`
  .modal-content {
    background: #ffffff;
    border: 0.063rem solid #000000;
    box-sizing: border-box;
    box-shadow: 0 0.25rem 0.875rem rgba(0, 0, 0, 0.14);
    border-radius: 0.25rem;
  }

  .modal-header,
  .modal-footer {
    border: none;
  }

  .modal-header {
    padding: 1.875rem 1.875rem 0.625rem;
  }

  .modal-body {
    padding: 0.75rem 1.875rem 0.25rem;
  }

  .modal-footer {
    padding: 0.25rem 1.875rem 1.875rem;
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const WarningIcon = styled(WarningRounded)`
  color: #d32f2f;
  font-size: 1.5rem !important;
`;

const Title = styled.h2`
  font-family: Open Sans, sans-serif;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #d32f2f;
  margin: 0;
`;

const Message = styled.p`
  font-family: Open Sans, sans-serif;
  font-size: 0.875rem;
  line-height: 1.625rem;
  font-weight: 600;
  margin-bottom: 0;
  color: #333;
`;

type Props = {
  show?: boolean;
  proceed: (value: boolean) => void;
  enableEscape?: boolean;
};

const DataLossWarningModal = ({ show, proceed, enableEscape = true }: Props) => {
  return (
    <Modal
      show={show}
      onHide={() => proceed(false)}
      backdrop={enableEscape ? true : "static"}
      keyboard={enableEscape}
      centered
    >
      <Modal.Header>
        <div>
          <SubHeader>Unlock Project</SubHeader>
          <TitleRow>
            <WarningIcon />
            <Title>Warning</Title>
          </TitleRow>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Message>
          Some records available when this project was locked may no longer
          exist. Unlocking may result in the loss of locked snapshot data.
          Please review before continuing.
        </Message>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="cancel" onClick={() => proceed(false)}>
          Cancel
        </Button>
        <Button onClick={() => proceed(true)}>
          <LockOpenOutlined /> Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default confirmable(DataLossWarningModal);
